<ion-header class="ion-no-border">
  <ion-toolbar class="ion-no-padding">
    @if (showLogo) {
      <ion-img slot="start" [alt]="logoAltName" [src]="logo"></ion-img>
    }

    @if (countdown?.warning) {
      <div slot="end" class="header__timer warning">
        <span>Survey expires in: {{ countdown.timer }}</span>
      </div>
    }
  </ion-toolbar>
</ion-header>
